// file = Html5QrcodePlugin.jsx
import {Html5Qrcode, Html5QrcodeScanner } from 'html5-qrcode';
import { useEffect, useState } from 'react';
import {useTranslation} from "react-i18next";

const qrcodeRegionId = "html5qr-code-full-region";
interface  Html5QrcodePlugin {
  fps: number;
  qrbox?: any;
  aspectRatio?: number;
  disableFlip?: boolean;
  verbose?: boolean;
  qrCodeSuccessCallback: (decodedText: any, decodedResult: any) => void;
  qrCodeErrorCallback: (e: any) => void;
}

const Html5QrcodePlugin = (props: Html5QrcodePlugin) => {
  const { t } = useTranslation("translations");
  const [html5QrcodeScanner, setHtml5QrcodeScanner] = useState<Html5QrcodeScanner | null>(null);
  const [hasVideoPermisssion, setHasVideoPermisssion] = useState<boolean>(false);
  const [showAllowPermissionMessage, setShowAllowPermissionMessage] = useState<boolean>(false);
  const checkForCamera = () => {
    navigator.mediaDevices.getUserMedia({ video : true })
        .then((result) => {
          setHasVideoPermisssion(true);
          setShowAllowPermissionMessage(false);
        })
        .catch((e) => {
          setHasVideoPermisssion(false);
          setShowAllowPermissionMessage(true);
        });
  };

  useEffect(() => {
    checkForCamera();
  }, []);
  
  useEffect(() => {
    if(!html5QrcodeScanner && hasVideoPermisssion) {
      const config = {
        fps: props.fps,
        qrbox: props.qrbox,
        aspectRatio: props.aspectRatio,
        disableFlip: props.disableFlip,
      };
      const verbose = props.verbose === true;
      let html5QrcodeScanner = new Html5QrcodeScanner(qrcodeRegionId, config, verbose);
      setHtml5QrcodeScanner(html5QrcodeScanner);
      html5QrcodeScanner.render(props.qrCodeSuccessCallback, props.qrCodeErrorCallback);
      
      // cleanup function when component will unmount
      return () => {
        html5QrcodeScanner.clear().catch(error => {
          console.error("Failed to clear html5QrcodeScanner. ", error);
        });
      };
    }
  }, [hasVideoPermisssion]);

  useEffect(() => {
    if(html5QrcodeScanner) {
      const d = document.getElementById("html5-qrcode-button-camera-permission");
      if(d) {
        d.click();
      }
    }
  }, [html5QrcodeScanner]);
  return (
      <>
        <div id={qrcodeRegionId} />
        {showAllowPermissionMessage && <div className="text-center text-red-400  ">
          {t("ALLOW_CAMERA_FOR_BARCODE_SCANING")}
        </div>}
      </>
  );
};

export default Html5QrcodePlugin;